import { Alert, Box, Typography } from "@mui/material";

import { BotaoComMenu } from "./BotaoComMenu";
import { Numero } from "./Numero";
import { IAcontecimentosHoje } from "./types";

/** Todo texto vem pronto do backend. */
export function AcontecimentosBloco({ dados }: { dados: IAcontecimentosHoje }) {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography component="h3" variant="h6" sx={{ fontFamily: "Sora" }}>
        {dados.titulo}
      </Typography>

      {dados.avisos.map((aviso) => (
        <Alert key={aviso} severity="info">
          {aviso}
        </Alert>
      ))}

      {dados.numeros.length > 0 && (
        <Box data-testid="grade-numeros" display="grid" gap={2} gridTemplateColumns="repeat(auto-fit, minmax(240px, 1fr))">
          {dados.numeros.map((n) => (
            <Numero key={n.rotulo} numero={n} />
          ))}
        </Box>
      )}

      <Box display="flex" gap={1} flexWrap="wrap">
        {dados.acoes.map((a, i) => (
          <BotaoComMenu key={a.rotulo} rotulo={a.rotulo} contratos={a.contratos} variante={i === 0 ? "contained" : "outlined"} />
        ))}
        <BotaoComMenu rotulo={dados.admitidos.rotulo} contratos={dados.admitidos.contratos} variante="outlined" />
      </Box>
    </Box>
  );
}
